import TabPage from "./../factories/tab-page";
import "./../bindings/bao-searcher";
import "./../bindings/bao-date-time-picker";
import "./../bindings/bao-date-time-box";
import BaseViewModel from "./../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import * as $ from "jquery";
import TabController from "./../factories/tab-controller";
import BaoDialog from "./../factories/bao-dialog";
import BaoRouter from "./../services/bao-router";
class NewScheduleGeneration extends BaseViewModel {
    Name: KnockoutObservable<string> = ko.observable("");
    ValidFromDateHtml: KnockoutObservable<string> = ko.observable("");
    ValidToDateHtml: KnockoutObservable<string> = ko.observable("");
    ShiftPlanModel: KnockoutObservable<string> = ko.observable("");
    ShiftPlanModelId: KnockoutObservable<string> = ko.observable("");
    ShiftGroupId: KnockoutObservable<string> = ko.observable("");
    PersonId: KnockoutObservable<string> = ko.observable("");
    PersonName: KnockoutObservable<string> = ko.observable("");
    ShiftPlanGenerated: KnockoutObservable<boolean> = ko.observable(false);
    ShiftPlanModelSearchBinding: Bindings.baoSearcher = {
        ObjectId: this.ShiftPlanModelId,
        ObjectValue: 'Name',
        SearchType: 'ShiftPlanModel',
        AutoComplete: true,
        AutoCompleteOpts: {
            preselect: false
        },
        AutoSearch: true
    };
    ShiftGroupSearchBinding: Bindings.baoSearcher = {
        ObjectId: this.ShiftGroupId,
        ObjectValue: 'Name_1',
        SearchType: 'ShiftGroup',
        AutoComplete: true,
        AutoCompleteOpts: {
            preselect: false
        },
        AutoSearch: true
    };
    PersonSearchBinding: Bindings.baoSearcher = {
        ObjectId: this.PersonId,
        ObjectValue: 'FullName',
        SearchType: 'Person',
        AutoComplete: true,
        AutoCompleteOpts: {
            preselect: false
        },
        AutoSearch: true
    };
    constructor(tabPage: TabPage) {
        super(tabPage);
        // url-hash-params could be changed
        tabPage.IsActiveTab.subscribe((val) => {
            if (val !== true) {
                return;
            }
            this.InitUrlParams();
        });
    }
    TabPage;
    CompleteCheck() {
        var isComplete: boolean = true;
        if ((this.PersonId() == null || this.PersonId() == "") && (this.ShiftPlanModelId() == null || this.ShiftPlanModelId() == "")) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillScheduleOrPersonField"), "info");
            return false;
        }
        if (this.ValidToDateHtml() == null || this.ValidFromDateHtml() == "")
            isComplete = false;
        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        // check if dates are correct
        let checker1 = parseInt(this.ValidFromDateHtml());
        let checker2 = parseInt(this.ValidToDateHtml());
        if (parseInt(this.ValidToDateHtml()) - parseInt(this.ValidFromDateHtml()) < 0) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgSerialTaskValidateStartEnd"), "info");
            isComplete = false;
        }
        return isComplete;
    }
    InitUrl() {
        return "";
    }
    GenerateShiftPlan() {
        this.ShiftPlanGenerated(false);
        if (this.CompleteCheck()) {
            this.TabPage.IsLoading(true);
            Bao.post("NewScheduleGeneration/GenerateShiftPlan", JSON.stringify({
                shiftPlanModelId: this.ShiftPlanModelId(),
                personId: this.PersonId(),
                validFromDateHtml: this.ValidFromDateHtml(),
                validToDateHtml: this.ValidToDateHtml()
            })).always(() => {
                this.TabPage.IsLoading(false);
            }).then(() => {
                this.ShiftPlanGenerated(true);
            });
        }
    }
    InitParamPersonId() {
        let personId = BaoRouter.getRouteValue("PersonId", this.TabPage);
        if (!Bao.Utils.String.IsNullOrEmpty(personId) && !Bao.Utils.String.IsNullOrEmpty(ko.unwrap(this.PersonId))) {
            this.PersonId(personId);
        }
    }
    InitParamPersonName() {
        let personName = BaoRouter.getRouteValue("PersonName", this.TabPage);
        if (!Bao.Utils.String.IsNullOrEmpty(personName) && !Bao.Utils.String.IsNullOrEmpty(ko.unwrap(this.PersonName))) {
            this.PersonName(personName);
        }
    }
    InitUrlParams() {
        return $.when(this.InitParamPersonId(), this.InitParamPersonName());
    }
    init() {
        return super.init().then(() => {
            Bao.post("NewScheduleGeneration/MyInit").done((serverResult) => {
                this.TabPage.Title(serverResult.TabName);
            });
            return this.InitUrlParams();
        });
    }
    loaded() {
        super.loaded();
        this.ValidFromDateHtml.subscribe(() => {
            this.ResetShiftPlanGenerated();
        });
        this.ValidToDateHtml.subscribe(() => {
            this.ResetShiftPlanGenerated();
        });
        this.ShiftPlanModel.subscribe(() => {
            this.ResetShiftPlanGenerated();
        });
        this.PersonName.subscribe(() => {
            this.ResetShiftPlanGenerated();
        });
    }
    // override, nothing to unlock!
    Unlock() {
        return $.Deferred<void>().resolve().promise();
    }
    ResetShiftPlanGenerated() {
        this.ShiftPlanGenerated(false);
    }
}
export default NewScheduleGeneration;